<template>
    <modal
        transition="nice-modal-fade" 
        class="new-modal-default emergency-contact-list"
        :name="modal_name" 
        :delay="100" 
        height="auto"
        :width="400"
        :adaptive="true" :scrollable="true"
    >
        <div class="v-modal-content" style="border-radius: 15px;background-color: #fff !important;">
            <div class="v-modal-header">
                <div></div>
                <div>
                    <span class="v-modal-dialog-title v-modal-title text-white">Scan QR Code</span>
                </div>
                <div>
                    <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideQrCode"></span>
                </div>
            </div>
            <div class="v-modal-body mt-10 my-8">
                <!-- <div class="row px-4 justify-content-center">
                    <img width="150" src="https://cdn.digicollect.com/cdn/facility/scan-qr-code-image.webp" /> 
                </div>
                <div class="d-flex align-items-center justify-content-center mt-8">
                    <button class="btn btn-new-outline-primary" @click="hideQrCode">Cancel</button>
                    <button class="btn btn-new-primary ml-3" @click="createNew">Next</button>
                </div> -->
                <div class="text-center">
                    <img src="/static/images/qr_scan_coming_soon.webp" height="200" />
                    <span class="fs-14 fw-600 text-new-blue d-block mt-4">
                        Feature coming soon!!
                    </span>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>

export default({
    data(){
        return{
            
        }
    },
    props: ['modal_name'],
    methods:{
        hideQrCode(){
            this.$emit('hideQrCode')
        },
        createNew(){
            // this.$router.push('/facilitymanagement/securityconcern/create?facility_id='+this.$route.query.facility_id)
            // this.$router.push('/facilitymanagement/securityconcern/create?facility_id=61fcaa5b3807ac3d0db3edf3')
        }
    }
})

</script>

<style scoped>
    
</style>
